<ion-list-header>{{ 'Choose Report Size' | translate }}</ion-list-header>
<ion-list>
  <ion-item (click)="dismissPopover(0);"button>{{ 'Fit To page' | translate }}</ion-item>
  <ion-item (click)="dismissPopover(1);"button>{{ 'Fit To Width' | translate }}</ion-item>
  <ion-item (click)="dismissPopover(2);"button>{{ 'Actual Size' | translate }}</ion-item>
</ion-list>

